import React from 'react';
import { CtaButton } from './CtaButton';
export function AgitationSection() {
  return <section className="bg-[#2a1f14] text-white py-20 px-4 border-t-8 border-[#b5634b]" data-id="element-1">
      <div className="max-w-4xl mx-auto text-center" data-id="element-2">
        <h2 className="font-oswald text-4xl md:text-6xl font-bold mb-6 uppercase tracking-tight" data-id="element-3">
          El problema no es que pienses.
        </h2>

        <h3 className="font-opensans text-2xl md:text-4xl font-bold mb-12" data-id="element-4">
          <span className="font-['Noto_Sans',_sans-serif] text-[#F2F6F0] bg-[#362B2B]" data-id="element-5">
            El problema es que nadie te enseñó a manejar tu mente.
          </span>
        </h3>

        <div className="font-opensans text-xl md:text-2xl space-y-6 text-gray-300 mb-12" data-id="element-6">
          <p data-id="element-7">La mente moderna está saturada.</p>
          <p data-id="element-8">
            Demasiada información. Demasiadas preocupaciones. Demasiadas cosas
            fuera de control.
          </p>
          <p className="pt-4" data-id="element-9">Por eso tantas personas viven con:</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16 max-w-3xl mx-auto" data-id="element-10">
          <div className="bg-[#b5634b]/15 border border-[#b5634b]/40 p-6 rounded-lg shadow-lg" data-id="element-11">
            <p className="font-oswald text-2xl font-bold text-[#d4956a] uppercase" data-id="element-12">
              Estrés mental
            </p>
          </div>
          <div className="bg-[#b5634b]/15 border border-[#b5634b]/40 p-6 rounded-lg shadow-lg" data-id="element-13">
            <p className="font-oswald text-2xl font-bold text-[#d4956a] uppercase" data-id="element-14">
              Ansiedad
            </p>
          </div>
          <div className="bg-[#b5634b]/15 border border-[#b5634b]/40 p-6 rounded-lg shadow-lg" data-id="element-15">
            <p className="font-oswald text-2xl font-bold text-[#d4956a] uppercase" data-id="element-16">
              Cansancio psicológico
            </p>
          </div>
        </div>

        <p className="font-opensans text-2xl md:text-3xl text-gray-200 mb-8 italic" data-id="element-17">
          Pero hay algo importante que debes saber.
        </p>

        <div className="py-8 border-t border-b border-[#5a4535] mb-12" data-id="element-18">
          <h2 className="font-oswald text-5xl md:text-7xl font-bold text-white uppercase tracking-widest" data-id="element-19">
            La mente puede entrenarse.
          </h2>
        </div>

        <div className="mt-8" data-id="element-20">
          <CtaButton text="DESCUBRE CÓMO ENTRENAR TU MENTE →" className="text-lg md:text-2xl py-4 px-8" data-id="element-21" />
        </div>
      </div>
    </section>;
}